<template>
  <div class="test height-100 pad">
    <div class="buttons flex">
      <div class="flex-1">
        <button class="button" :class="{'is-loading': loading}" @click="go()">Test</button>
        <button class="button" :class="{'is-loading': loading}" @click="arrayifyCollectionKey('jobs', 'jobName')">Arrayify Job Names</button>
        <button class="button" :class="{'is-loading': loading}" @click="arrayifyCollectionKey('clients', 'name')">Arrayify Client Names</button>
      </div>
      <div>
        <button class="button is-danger" :class="{'is-loading': clearingXeroData}" @click="clearXeroData()">CLEAR XERO DATA</button>
      </div>
    </div>
    <div class="pad"></div>
    <b-message v-if="msg">
      {{ msg }}
    </b-message>

    <div class="center pad-20" v-if="items === null"><fa icon="spinner" pulse /></div>
    <table class="table is-narrow is-bordered" v-if="items">
      <thead>
        <tr>
          <th>i</th>
          <th>number</th>
          <th>name</th>
          <th>poNumbers</th>
          <th>poNumberArr</th>
          <th>hasPoNumber</th>
          <th>woNumbers</th>
          <th>woNumberArr</th>
          <th>hasWoNumber</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in items" :key="item._id">
          <td>{{ i + 1 }}</td>
          <td>{{ item.number }}</td>
          <td>{{ item.jobName }}</td>
          <td>{{ item.poNumbers }}</td>
          <td>{{ item.poNumberArr }}</td>
          <td>{{ item.hasPoNumber }}</td>
          <td>{{ item.woNumbers }}</td>
          <td>{{ item.woNumberArr }}</td>
          <td>{{ item.hasWoNumber }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
// import firebase from 'firebase/app'
// import 'firebase/firestore'
export default {
  data () {
    return {
      items: [],
      loading: false,
      msg: null,
      data: null,
      clearingXeroData: false
    }
  },
  created () {
    document.title = 'TEST'
    // this.subs.test = this.$fs.collection('jobs')
    //   .orderBy('number', 'asc')
    //   .onSnapshot(ss => {
    //     this.items = this.$ssToArr(ss)
    //   })
  },
  methods: {
    async go () {
      console.log('GO!')
      this.loading = true
      try {
        // this.addPoAndWoArrs()
        // this.clearDocExpiryEmailAlertDates()
        // this.fixNSWasNST()
        // this.fixJobExpenses()
        await this.poArrayify()

        // const resp = await this.$api('/test')
        // console.log(resp)
      } catch (error) {
        console.error(error)
      }
      this.loading = false

      console.log('DONE')
    },
    async poArrayify () {
      console.log('poArrayify')
      const ss = await this.$firestore.collection('purchaseOrders').get()
      const arr = this.$ssToArr(ss)
      console.log('arr.length', arr.length)
      let batch = this.$firestore.batch()
      let batchCount = 0
      let i = 0
      for (const po of arr) {
        if (po._id === 'settings') continue
        const p = (++i / arr.length * 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
        if (po.searchArr) {
          console.log(p, po._id, 'ALREADY HAS SEARCH ARR')
          continue
        }
        const strArr = []
        for (const item of po.items || []) {
          const itemArr = this.$utils.smartArrayifyStr(item.description || '')
          strArr.push(...itemArr)
          // console.log(' ', item.description, itemArr)
        }
        const searchArr = [...new Set(strArr)]
        console.log(p, po._id, searchArr.length)
        const ref = this.$firestore.doc(`/purchaseOrders/${po._id}`)
        batch.update(ref, { searchArr })
        if (++batchCount >= 500) {
          console.log('commit')
          await batch.commit()
          batch = this.$firestore.batch()
          batchCount = 0
        }
      }
      if (batchCount) {
        console.log('commit')
        await batch.commit()
      }
    },
    async arrifyMaterialDescs () {
      const ss = await this.$fs.collection('settings')
        .where('_type', '==', 'materials')
        .get()
      const arr = this.$ssToArr(ss)
      console.log(arr.length)

      let batch = this.$fs.batch()
      let batchCount = 0
      let totalBatchCount = 0
      for (const item of arr) {
        const valueArr = this.$utils.smartArrayifyStr(item.value)
        const updateData = { valueArr, lowerCaseValue: item.value.trim().toLowerCase() }
        // console.log(item._id, item.value, updateData)
        const docRef = this.$fs.doc(`/settings/${item._id}`)
        batch.update(docRef, updateData)
        if (++batchCount >= 500) {
          await batch.commit()
          totalBatchCount += batchCount
          console.log('commit', batchCount, totalBatchCount)
          batchCount = 0
          batch = this.$fs.batch()
        }
      }
      if (batchCount) {
        await batch.commit()
        totalBatchCount += batchCount
        console.log('commit', batchCount, totalBatchCount)
      }
    },
    async fixJobExpenses () {
      console.log('fixJobExpenses')
      try {
        let ss = await this.$fs.collection('jobs')
          .where('completed', '==', false)
          .where('cancelled', '==', false)
          .get()
        const arr = this.$ssToArr(ss)
        console.log('JOBS COUNT', arr.length)
        for (const job of arr) {
          let totalMaterials = 0

          ss = await this.$fs.collection('materials').where('jobNumber', '==', job.number).get()
          const materials = this.$ssToArr(ss)
          for (let m of materials || []) {
            totalMaterials += m.total
          }

          ss = await this.$fs.collection('purchaseOrders').where('jobNumber', '==', job.number).get()
          const purchaseOrders = this.$ssToArr(ss)
          for (let po of purchaseOrders || []) {
            let cost = 0
            if (po.xeroStatus === 'BILLED') {
              cost = Number(po.billedSubTotal || 0)
            } else {
              cost = Number(po.totalCost || 0)
            }
            let markup = Number(po.markup || 15)
            const poTotal = cost + (cost * (markup / 100))
            totalMaterials += poTotal
          }

          let totalExpenses = totalMaterials
          if (job.totalLabor) totalExpenses += job.totalLabor

          if (job.totalExpenses !== totalExpenses) {
            console.log(job.number, job.totalExpenses, totalExpenses)
          }
        }
        console.log('DONE')
      } catch (error) {
        this.$showError(error)
      }
    },
    async fixNSWasNST () {
      console.log('fixNSWasNST')
      try {
        // const field = 'details.state'
        const field = 'emergencyContact.state'
        console.log(field)
        const ss = await this.$fs.collection('userProfiles')
          .where(field, '==', 'NST')
          .get()
        const arr = this.$ssToArr(ss)
        console.log('arr.length', arr.length)
        const batch = this.$fs.batch()
        for (const item of arr) {
          const ref = this.$fs.doc(`/userProfiles/${item._id}`)
          console.log(item.details.firstName, item.details.lastName, item.details.state)
          const updateData = {}
          updateData[field] = 'NSW'
          batch.update(ref, updateData)
        }
        await batch.commit()
      } catch (error) {
        this.$showError(error)
      }
      console.log('fixNSWasNST DONE')
    },
    async clearDocExpiryEmailAlertDates () {
      const ss = await this.$fs.collection('userProfiles').get()
      const arr = this.$ssToArr(ss)
      const batch = this.$fs.batch()
      for (const item of arr) {
        console.log(item._id)
        console.log(' - personalInjuryIncomeProtectionInsuranceLastEmailAlertDate', item.personalInjuryIncomeProtectionInsuranceLastEmailAlertDate)
        console.log(' - publicLiabilityInsuranceDocumentLastEmailAlertDate', item.personalInjuryIncomeProtectionInsuranceLastEmailAlertDate)
        const docRef = this.$fs.doc(`/userProfiles/${item._id}`)
        batch.update(docRef, {
          'workerDetails.personalInjuryIncomeProtectionInsuranceLastEmailAlertDate': 0,
          'workerDetails.publicLiabilityInsuranceDocumentLastEmailAlertDate': 0
        })
      }
      await batch.commit()
      console.log('DONE!')
    },
    async addPoAndWoArrs () {
      const ss = await this.$fs.collection('jobs')
        .orderBy('number', 'asc')
        .get()
      const arr = this.$ssToArr(ss)
      let count = 0

      let batch = this.$fs.batch()
      let batchCount = 0

      for (const job of arr) {
        count++

        const poNumberArr = []
        for (const item of job.poNumbers) {
          if (item.number && item.number.trim()) poNumberArr.push(item.number.trim().toLowerCase())
        }
        // console.log('poNumberArr', poNumberArr)

        const woNumberArr = []
        for (const item of job.woNumbers) {
          if (item.number && item.number.trim()) woNumberArr.push(item.number.trim().toLowerCase())
        }
        // console.log('woNumberArr', woNumberArr)

        if (batchCount === 500) {
          console.log('COMMITING', batchCount)
          await batch.commit()
          batch = this.$fs.batch()
          batchCount = 0
        }

        const docRef = this.$fs.doc(`/jobs/${job._id}`)
        // batch.update(docRef, { poNumberArr, woNumberArr })
        batch.update(docRef, {
          hasPoNumber: poNumberArr.length > 0,
          hasWoNumber: woNumberArr.length > 0
        })
        batchCount++

        console.log(count, job.number, 'done')
        // if (count >= 2) break
      }

      console.log('COMMITING', batchCount)
      await batch.commit()
    },
    dunnno () {
      // this.loading = true
      // let ss = await this.$fs.collection('xeroBills')
      //   .where('xeroUpdatedTimestamp', '>', 0)
      //   .get()
      // let items = this.$ssToArr(ss)
      // if (!items) {
      //   console.log('??', items)
      //   return
      // }
      // const batch = this.$fs.batch()
      // for (const item of items) {
      //   console.log(item.invoiceNumber)
      //   const docRef = this.$fs.doc(`/xeroBills/${item._id}`)
      //   batch.update(docRef, { invoiceNumberArr: this.$utils.arrayifyStr(item.invoiceNumber) })
      // }
      // await batch.commit()
      // this.loading = false
    },
    async clearXeroData () {
      this.clearingXeroData = true
      if (!await this.$confirm({ type: 'is-danger', title: 'confirm clear', message: 'Are you sure you want to clearall xero data' })) {
        return
      }
      try {
        const batch = this.$fs.batch()

        let ss = await this.$fs.collection('suppliers').where('xeroContact', '==', true).get()
        let suppliers = this.$ssToArr(ss) || []
        for (let doc of suppliers) {
          if (doc._id === 'settings') continue
          let docRef = this.$fs.doc(`/suppliers/${doc._id}`)
          batch.delete(docRef)
        }

        ss = await this.$fs.collection('purchaseOrders').get()
        let puchaseOrders = this.$ssToArr(ss) || []
        for (let doc of puchaseOrders) {
          if (doc._id === 'settings') continue
          let docRef = this.$fs.doc(`/purchaseOrders/${doc._id}`)
          batch.delete(docRef)
        }

        ss = await this.$fs.collection('xeroBills').get()
        let xeroBills = this.$ssToArr(ss) || []
        for (let doc of xeroBills) {
          if (doc._id === 'settings') continue
          let docRef = this.$fs.doc(`/xeroBills/${doc._id}`)
          batch.delete(docRef)
        }

        await batch.commit()
      } catch (error) {
        this.$showError(error)
      }

      this.clearingXeroData = false
    },
    async arrayifyCollectionKey (collection, key) {
      let ss = await this.$fs.collection(collection).get()
      let items = this.$ssToArr(ss) || []
      const batches = []
      let batch = this.$fs.batch()
      batches.push(batch)
      let i = 0
      for (let item of items) {
        const strArr = this.$utils.arrayifyStr(item[key])
        // console.log(item[key], strArr)
        const updateData = {}
        updateData[`${key}Arr`] = strArr
        batch.update(this.$fs.doc(`/${collection}/${item._id}`), updateData)
        i++
        if (i % 400 === 0) {
          batch = this.$fs.batch()
          batches.push(batch)
        }
      }

      if (!await this.$confirm({
        type: 'is-warning',
        title: `Arrayify ${collection} ${key}`,
        message: `Are you sure? ${i} updates (${batches.length})`
      })) {
        return
      }

      try {
        i = 0
        for (const b of batches) {
          console.log('batch ' + i++)
          await b.commit()
        }
      } catch (error) {
        this.$showError(error)
      }
      console.log('DONE')
    }
  }
}
</script>
